import { pick } from 'lodash'

const transformToUpdateIngredientSimpleDetailsArgs = data =>
  pick(data, ['description', 'position', 'isExcludedFromSearch'])

export default transformToUpdateIngredientSimpleDetailsArgs
